export class Constants {

  static readonly CHART = {
    MAX_BAR_SIZE: 80,
    HEIGHT_CLASS: 'h-48',
  };
}